import * as React from 'react';
import EkonomiskAnalysDataErrorPage from '../EkonomiskAnalysDataErrorPage/EkonomiskAnalysDataErrorPage';
import { SidePanels } from '../../EkonomiskAnalysMain/EkonomiskAnalysMain';
import { EkonomiskAnalysSelectConsumer } from '../../SideMenu/Components/AnalysSelect/Context/EkonomiskAnalysSelectContext';

interface IProps {
  openSideMenu: (panel?: SidePanels, callback?: () => void) => () => void;
  openCreateNew: () => void;
}

/**
 * En vy för när ingen analys är vald
 */
class EkonomiskAnalysNoAnalysSelectedPage extends React.Component<IProps> {
  onClick = (inputSelectRef: React.RefObject<HTMLInputElement | null>) => () => {
    this.props.openSideMenu(SidePanels.select, () =>
      this.focusInput(inputSelectRef)
    )();
  };

  focusInput = (inputSelectRef: React.RefObject<HTMLInputElement | null>) => {
    if (inputSelectRef.current) {
      inputSelectRef.current.focus({ preventScroll: true });
    }
  };

  render() {
    'Ingen analys vald';
    'Välj analys';
    return (
      <EkonomiskAnalysSelectConsumer>
        {({ selectInputRef }) => (
          <EkonomiskAnalysDataErrorPage
            errorText="Ingen analys vald"
            buttonText="Välj analys"
            onButtonClick={this.onClick(selectInputRef)}
            testId="NoAnalysSelectedPage"
            openCreateNew={this.props.openCreateNew}
          />
        )}
      </EkonomiskAnalysSelectConsumer>
    );
  }
}

export default EkonomiskAnalysNoAnalysSelectedPage;
